module.exports = __webpack_public_path__ + "static/media/sunset.3980f922.png";